import React from 'react';
import { AxiosResponse } from 'axios';
import { ReactNode } from 'react';
import { TFunction } from 'i18next';
import { Namespace } from '../../../translation/namespace';

export function mapTeamroomInviteError(response: AxiosResponse, t: TFunction): ReactNode | undefined {
  if (response.data?.errorType !== 'teamroomInvitePartiallyFailed') {
    return undefined;
  }

  const lines = [];

  if (response.data.usersAlreadyMember?.length) {
    lines.push(
      t(`${Namespace.TeamroomManagement}:error.teamroomInvitePartiallyFailed.alreadyMember`, {
        users: response.data.usersAlreadyMember.join(', '),
      })
    );
  }

  if (response.data.usersWithoutPermission?.length) {
    lines.push(
      t(`${Namespace.TeamroomManagement}:error.teamroomInvitePartiallyFailed.noPermission`, {
        users: response.data.usersWithoutPermission.join(', '),
      })
    );
  }

  return (
    <div>
      {lines.map((line, index) => (
        <p key={index}>{line}</p>
      ))}
    </div>
  );
}
